import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import Select from 'react-select';
import { SelectStyles as baseStyles } from '../../../../style/components/react-select';
import classNames from 'classnames';

const SelectInput = ({
  id,
  handleInputChange,
  metaTag,
  fileIndex,
  tagIndex,
  isSearchable,
  userInput,
  intl,
  error,
  setError,
  validateInput,
  hasTriedSubmitting,
}) => {
  const [options, setOptions] = useState([]);
  useEffect(() => {
    if (
      metaTag.list &&
      Array.isArray(metaTag.list) &&
      metaTag.list.length > 0
    ) {
      const temp = [];
      metaTag.list.map((option) => {
        if (typeof option == 'string') {
          temp.push({ label: option, value: option });
        }
      });
      setOptions(temp);
    }
  }, []);

  // Extend the base styles to include error state
  const extendedStyles = {
    ...baseStyles,
    control: (styles, { isDisabled, isFocused, isSelected }) => ({
      ...baseStyles.control(styles, { isDisabled, isFocused, isSelected }),
      borderColor: error
        ? 'red'
        : isSelected || isFocused
        ? '#5e2064'
        : '#ced4da',
      '&:hover': {
        borderColor: error ? 'red' : '#5e2064',
      },
    }),
  };

  //Effect to validate user input on submit
  useEffect(() => {
    if (hasTriedSubmitting > 0) validateInput(userInput);
  }, [hasTriedSubmitting]);

  //Effect to monitor changesin input
  useEffect(() => {
    if (userInput.length != 0) setError('');
  }, [userInput]);

  return (
    <>
      <Select
        id={'meta_' + metaTag.meta.id}
        key={id}
        options={options}
        name={metaTag.meta.name}
        value={options.filter(function (option) {
          return option.value === userInput;
        })}
        searchable={isSearchable ? true : false}
        openOnClick
        onChange={(e) => {
          setError('');
          handleInputChange(fileIndex, tagIndex, e.value);
        }}
        simpleValue
        placeholder={intl.formatMessage({ id: 'general.select' })}
        styles={extendedStyles}
        className={classNames(error && 'input-error')}
        onBlur={() => {
          validateInput(userInput);
        }}
        error={error}
      />
      {error && <div className="error-message">{error}</div>}
    </>
  );
};

export default injectIntl(SelectInput);
